export const BG_COLORS = ['grey', 'white'];
export const SIZES = ['small', 'regular'];
